"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.registerDefaultFontFaces = exports.DefaultFontStyles = exports.createFontStyles = void 0;
var tslib_1 = require("tslib");
tslib_1.__exportStar(require("./FluentFonts"), exports);
var createFontStyles_1 = require("./createFontStyles");
Object.defineProperty(exports, "createFontStyles", { enumerable: true, get: function () { return createFontStyles_1.createFontStyles; } });
var DefaultFontStyles_1 = require("./DefaultFontStyles");
Object.defineProperty(exports, "DefaultFontStyles", { enumerable: true, get: function () { return DefaultFontStyles_1.DefaultFontStyles; } });
Object.defineProperty(exports, "registerDefaultFontFaces", { enumerable: true, get: function () { return DefaultFontStyles_1.registerDefaultFontFaces; } });
//# sourceMappingURL=index.js.map